import { useState, useCallback } from 'react';

export interface UseRefCallbackResult {
  current: HTMLElement | null,
  ref: (node: Element) => void,
}

export default function useRefCallback(initialValue: any = null): UseRefCallbackResult {
  const [current, setCurrent] = useState(initialValue);

  const refCallback = useCallback((node: Element) => {
    setCurrent(node);
  }, []);

  return {
    current,
    ref: refCallback,
  };
}
